/** Shared upload contract. These files are data; none are executed or rendered as active pages. */
export const FILE_MEDIA_EXTENSIONS = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-excel.sheet.macroenabled.12': 'xlsm',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'text/plain': 'txt', 'text/markdown': 'md', 'text/csv': 'csv', 'text/tab-separated-values': 'tsv',
    'application/json': 'json', 'application/xml': 'xml', 'text/yaml': 'yaml',
    'text/html': 'html', 'image/svg+xml': 'svg',
    'application/zip': 'zip', 'application/gzip': 'gz', 'application/x-tar': 'tar',
    'application/vnd.gyro.skill': 'skill',
};
const NATIVE_MEDIA = {
    png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', gif: 'image/gif', webp: 'image/webp', pdf: 'application/pdf',
};
const FILE_EXTENSIONS = {
    ...Object.fromEntries(Object.entries(FILE_MEDIA_EXTENSIONS).map(([type, extension]) => [extension, type])),
    markdown: 'text/markdown', jsonl: 'text/plain', ndjson: 'text/plain', yml: 'text/yaml',
    htm: 'text/html', tgz: 'application/gzip',
    ...Object.fromEntries(['log', 'ini', 'cfg', 'conf', 'toml', 'sql', 'py', 'js', 'jsx', 'ts', 'tsx', 'css', 'scss', 'cs', 'java', 'c', 'cpp', 'h', 'sh', 'ps1', 'bat', 'eml', 'ics', 'vcf', 'rst', 'tex'].map(extension => [extension, 'text/plain'])),
};
export const FILE_UPLOAD_ACCEPT = [...Object.values(NATIVE_MEDIA), ...Object.keys(FILE_MEDIA_EXTENSIONS), ...Object.keys(FILE_EXTENSIONS).map(extension => `.${extension}`)];
export const FILE_UPLOAD_DESCRIPTION = 'PDF, images, Office, Markdown, text/data, ZIP and skill packages · up to 5 MB each';
export const FILE_TEXT_MAX_CHARACTERS = 128_000;
export const FILE_TEXT_TOTAL_CHARACTERS = 256_000;
export function fileMediaType(name, declared = '') {
    const extension = name.toLowerCase().split('.').at(-1) ?? '';
    if (Object.hasOwn(NATIVE_MEDIA, extension))
        return NATIVE_MEDIA[extension];
    if (Object.hasOwn(FILE_EXTENSIONS, extension))
        return FILE_EXTENSIONS[extension];
    const type = declared.toLowerCase().split(';')[0].trim();
    if (type === 'application/x-zip-compressed')
        return 'application/zip';
    if (type === 'text/xml')
        return 'application/xml';
    if (type === 'application/x-gzip')
        return 'application/gzip';
    return Object.values(NATIVE_MEDIA).includes(type) || Object.hasOwn(FILE_MEDIA_EXTENSIONS, type) ? type : null;
}
export function fileTypeLabel(name, mediaType) {
    if (mediaType === 'application/pdf')
        return 'PDF';
    const extension = name?.split('.').at(-1)?.toLowerCase();
    return (extension && fileMediaType(name) ? extension : FILE_MEDIA_EXTENSIONS[mediaType] ?? 'file').toUpperCase();
}
//# sourceMappingURL=fileTypes.js.map